import { Button } from '@trackman/web-shared-components';
import './OrderSummary.scss';
import { useCartStore } from 'stores/Webshop/CartStore';
import { CartItem } from 'types/cart';
import { useTranslation } from 'react-i18next';

import { OrderSummaryCardInteractive } from '../OrderSummaryCards/OrderSummaryCardInteractive/OrderSummaryCardInteractive';
import { DefaultRoutes } from 'Routes';
import { useNavigate } from 'react-router-dom';

export const OrderSummary = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const setActiveStep = useCartStore((state) => state.setActiveStep);

  const itemsInCart: CartItem[] = useCartStore((state) => state.items);
  const agreedToTermsAndConditions = useCartStore((state) => state.agreedToTermsAndConditions);

  return (
    <div className='order-summary'>
      <OrderSummaryCardInteractive />
      {itemsInCart.length > 0 ? (
        <Button className='cart-action-button' intent='primary' disabled={!agreedToTermsAndConditions} onClick={() => setActiveStep(1)}>
          {t('ContinueToPayment', { ns: 'webshop' })}
        </Button>
      ) : (
        <Button className='cart-action-button' intent='primary' onClick={() => navigate(DefaultRoutes.Webshop)}>
          {t('ViewWebshop', { ns: 'webshop' })}
        </Button>
      )}
    </div>
  );
};
